export const C1_ELO_HEIGHT_GROUPS = ["Leuchten", "Taster / Panels", "Steckdosen", "Feststrom", "Boden / Decke"] as const;

/** Negative Z values identify symbolic mounting heights; physical heights use metres. */
export const C1_ELO_HEIGHT_DEFAULTS = [
  { z: -1, symbol: "$S1", group: "Steckdosen", shortLabel: "Boden", label: "Steckdosen Boden", height: 0.30 },
  { z: -2, symbol: "$S2", group: "Steckdosen", shortLabel: "Arbeitsplatte", label: "Steckdosen Arbeitsplatte", height: 1.15 },
  { z: -3, symbol: "$S3", group: "Steckdosen", shortLabel: "Waschbecken", label: "Steckdosen Waschbecken", height: 1.15 },
  { z: -4, symbol: "$S4", group: "Steckdosen", shortLabel: "Lichtschalter", label: "Steckdose Lichtschalter", height: 1.00 },
  { z: -5, symbol: "$S5", group: "Steckdosen", shortLabel: "Dunstabzug", label: "Steckdose Dunstabzug", height: 2.00 },
  { z: -6, symbol: "$T", group: "Taster / Panels", shortLabel: "Taster", label: "Taster", height: 1.05 },
  { z: -7, symbol: "$P", group: "Taster / Panels", shortLabel: "Panel", label: "Panels", height: 1.50 },
  { z: -8, symbol: "$L1", group: "Leuchten", shortLabel: "Wand", label: "Wandleuchten", height: 1.75 },
  { z: -9, symbol: "$L2", group: "Leuchten", shortLabel: "Decke", label: "Deckenleuchten", height: 2.70 },
  { z: -15, symbol: "$L3", group: "Leuchten", shortLabel: "Bettwand", label: "Bett-Wandleuchten", height: 1.10 },
  { z: -16, symbol: "$L4", group: "Leuchten", shortLabel: "Badspiegel seitlich", label: "Badezimmerspiegel (seitliche Leuchten)", height: 1.65 },
  { z: -10, symbol: "$F1", group: "Feststrom", shortLabel: "Anschluss 1", label: "Feststrom-1", height: 0.30 },
  { z: -11, symbol: "$F2", group: "Feststrom", shortLabel: "Anschluss 2", label: "Feststrom-2", height: 0.60 },
  { z: -12, symbol: "$F3", group: "Feststrom", shortLabel: "Dunstabzug", label: "Feststrom Dunstabzug", height: 2.00 },
  { z: -13, symbol: "$G", group: "Boden / Decke", shortLabel: "Boden", label: "Ground / Boden", height: 0 },
  { z: -14, symbol: "$C", group: "Boden / Decke", shortLabel: "Decke", label: "Ceiling / Decke", height: 2.70 },
] as const;
export type C1_EloHeightSetting = { z: number; height: number };
export type C1_EloPosition = { x: number; y: number; z?: number };

/** Repair missing entries individually without resetting any configured heights. */
export function normalizeEloHeights(input?: readonly C1_EloHeightSetting[]): C1_EloHeightSetting[] {
  return C1_ELO_HEIGHT_DEFAULTS.map(entry => {
    const saved = input?.find(value => value.z === entry.z);
    return { z: entry.z, height: saved && Number.isFinite(saved.height) && saved.height >= 0 ? saved.height : entry.height };
  });
}

export function resolveEloHeight(z: number | undefined, settings?: readonly C1_EloHeightSetting[]): number {
  if (z === undefined || !Number.isFinite(z)) return 0;
  if (z >= 0) return z;
  return normalizeEloHeights(settings).find(entry => entry.z === z)?.height ?? 0;
}
